import { TCategoryAction, CategoryActionTypes } from './categoryActions';
import { ICategoryState } from './categoryContext';

export const categoryReducer = (state: ICategoryState, action: TCategoryAction): ICategoryState => {
	switch (action.type) {
		case CategoryActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case CategoryActionTypes.SET_CATEGORIES:
			return {
				...state,
				categories: action.payload.categories,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CategoryActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case CategoryActionTypes.TOGGLE_REMEMBER_MY_CHOICE:
			return {
				...state,
				rememberMyChoice: action.payload.rememberMyChoice,
			};
		case CategoryActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				categories: action.payload.categories,
				IDSelectedRestaurant: null,
				currentPage: 1,
			};
		case CategoryActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				currentPage: 1,
			};
		case CategoryActionTypes.SET_IDS_SELECTED_CATEGORY_TYPES:
			return {
				...state,
				IDsSelectedCategoryTypes: action.payload.IDsSelectedCategoryTypes,
				currentPage: 1,
			};
		case CategoryActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedRestaurant: null,
				IDsSelectedCategoryTypes: [],
				currentPage: 1,
			};
		case CategoryActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case CategoryActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case CategoryActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case CategoryActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CategoryActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS:
			return {
				...state,
				IDForAssignRestaurants: action.payload.IDForAssignRestaurants,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CategoryActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CategoryActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
				isInitializedSelectCustomerModal: true,
			};
		default:
			return state;
	}
};
